import { render, staticRenderFns } from "./SerieDetail.vue?vue&type=template&id=f64fd066&scoped=true&"
import script from "./SerieDetail.vue?vue&type=script&lang=js&"
export * from "./SerieDetail.vue?vue&type=script&lang=js&"
import style0 from "./SerieDetail.vue?vue&type=style&index=0&id=f64fd066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64fd066",
  null
  
)

export default component.exports